var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import { GBTypography, MultiSelectDropdown } from '@leapfinance/geebee-component-library';
import classNames from 'classnames';
import { isFalsy } from '../../../../utils/common';
import CustomFilterPoppper from './CustomMultiselectFilterPoppper';
var MultiSelectFilter = function (props) {
    var _a;
    var _b = __read(useState(false), 2), inFocus = _b[0], setInFocus = _b[1];
    var _c = __read(useState(false), 2), open = _c[0], setOpen = _c[1];
    var _d = __read(useState(null), 2), value = _d[0], setValue = _d[1];
    var _e = __read(useState(null), 2), prevValues = _e[0], setPrevValues = _e[1];
    useEffect(function () {
        setValue((props === null || props === void 0 ? void 0 : props.values) || null);
    }, [props === null || props === void 0 ? void 0 : props.values]);
    useEffect(function () {
        if (inFocus) {
            setTimeout(function () {
                setOpen(true);
                setPrevValues(value);
            }, 300);
        }
        else {
            setOpen(false);
        }
    }, [inFocus]);
    var handleClose = function (isApplied) {
        var _a;
        if (isApplied) {
            (_a = props === null || props === void 0 ? void 0 : props.onApply) === null || _a === void 0 ? void 0 : _a.call(props, value);
        }
        else {
            setValue(prevValues);
        }
        setInFocus(false);
    };
    return (React.createElement(MultiSelectDropdown, __assign({ "data-hasValue": !isFalsy(value), disableClearable: false, value: value, textInputProps: {
            label: props.label,
            keepDefaultLabelBehaviour: true,
            InputProps: {
                sx: function (theme) {
                    var _a, _b, _c, _d;
                    return !isFalsy(value) && !open
                        ? {
                            '&.MuiOutlinedInput-root': {
                                backgroundColor: (_a = theme.palette.primary) === null || _a === void 0 ? void 0 : _a['200'],
                                fieldSet: {
                                    borderColor: (_b = theme.palette.primary) === null || _b === void 0 ? void 0 : _b['500']
                                },
                                ':hover': {
                                    backgroundColor: (_c = theme.palette.primary) === null || _c === void 0 ? void 0 : _c['200']
                                    // fieldSet: {
                                    //   borderColor: theme.palette.primary?.['500']
                                    // }
                                },
                                '.MuiInputAdornment-positionStart': {
                                    '.MuiTypography-root': {
                                        color: (_d = theme.palette.primary) === null || _d === void 0 ? void 0 : _d['500']
                                    }
                                },
                                input: {
                                    textOverflow: 'ellipsis'
                                }
                            }
                        }
                        : {
                            '&.MuiOutlinedInput-root': {
                                backgroundColor: 'white'
                            }
                        };
                }
            }
        }, open: open, onOpen: function () {
            setInFocus(true);
        }, onClose: function (event, reason) {
            if (reason === 'blur' || reason === 'toggleInput') {
                handleClose === null || handleClose === void 0 ? void 0 : handleClose();
            }
        }, className: classNames(' lfc-transition-all lfc-w-[190px]'
        // { 'lfc-w-[190px]': !inFocus }
        // { 'lfc-w-[250px]': inFocus },
        ), options: (_a = props.options) !== null && _a !== void 0 ? _a : [], getOptionDisabled: props === null || props === void 0 ? void 0 : props.getOptionDisabled, PopperComponent: CustomFilterPoppper, isOptionEqualToValue: function (option, value) { return (option === null || option === void 0 ? void 0 : option.value) === (value === null || value === void 0 ? void 0 : value.value); }, renderCustomLabel: function (option) {
            var _a, _b;
            return (React.createElement("div", { className: "lfc-flex lfc-items-end lfc-justify-between lfc-w-full" },
                React.createElement("div", null,
                    React.createElement(GBTypography, { variant: "body3" }, option === null || option === void 0 ? void 0 : option.label),
                    typeof (option === null || option === void 0 ? void 0 : option.count) === 'number' ? (React.createElement(GBTypography, { variant: "caption1", className: "lfc-text-gbTokens-grey-A600 lfc-ml-1" },
                        "(", (_a = option === null || option === void 0 ? void 0 : option.count) !== null && _a !== void 0 ? _a : 0,
                        ")")) : null), (_b = props === null || props === void 0 ? void 0 : props.optionEndItem) === null || _b === void 0 ? void 0 :
                _b.call(props, option)));
        }, onChange: function (_, value, reason) {
            var _a;
            setValue(value);
            if (reason === 'clear') {
                setValue(null);
                (_a = props === null || props === void 0 ? void 0 : props.onApply) === null || _a === void 0 ? void 0 : _a.call(props, null);
            }
        }, componentsProps: {
            popper: {
                onApply: function () {
                    handleClose === null || handleClose === void 0 ? void 0 : handleClose(true);
                }
            }
        }, size: "small" }, props === null || props === void 0 ? void 0 : props.filterComponentProps)));
};
export default MultiSelectFilter;
//# sourceMappingURL=MultiSelectFilter.js.map